import React from "react";
import CharchaShorts from "./CharchaShorts";
import CharchaVideo from "./CharchaVideo";
import CharachaLekh from "./CharachaLekh";
import Graphics from "./Graphics";
import data from '../../common/ShareText.json';

const AllEpisodeTab = ({ episodeData, handleclick, handleShareData, episodeId }) => {
  const { text, graphics, shorts, video } = episodeData.parikshadata || {};

  return (
    <>
      <section className="charcha_sec charcha_sec_pad">
        <img src="/assets/images/wings.png" className="wing_img_pos" alt="" />
        <div className="scoll_mar" id="myScrollspy">
          <div className="">
            <div className="">
              <ul className="navbar-nav scroospy_tab">
                <li className="nav-item">
                  <a className="nav-link active" href="#charcha">
                    <img
                      src="/assets/images/shortred.svg"
                      className="red_images"
                      alt=""
                    />
                    <img
                      src="/assets/images/shortwhite.svg"
                      className="white_images"
                      alt=""
                    />
                    Shorts
                  </a>
                </li>

                <li className="nav-item">
                  <a className="nav-link" href="#videos">
                    <img
                      src="/assets/images/videored.svg"
                      className="red_images"
                      alt=""
                    />
                    <img
                      src="/assets/images/videowhite.svg"
                      className="white_images"
                      alt=""
                    />
                    Videos
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#text">
                    <img
                      src="/assets/images/textred.svg"
                      className="red_images"
                      alt=""
                    />
                    <img
                      src="/assets/images/textwhite.svg"
                      className="white_images"
                      alt=""
                    />
                    Text
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#graphics">
                    <img
                      src="/assets/images/textred.svg"
                      className="red_images"
                      alt=""
                    />
                    <img
                      src="/assets/images/textwhite.svg"
                      className="white_images"
                      alt=""
                    />
                    Graphics
                  </a>
                </li>
              </ul>

              <div id="charcha">
                {shorts && (
                  <CharchaShorts
                    shortsData={shorts}
                    handleclick={handleclick}
                    isEpisode={true}
                    sharetext={data[episodeId]}
                    handleShareData={handleShareData}
                    type="shorts"
                  />
                )}
              </div>

              <div id="videos">
                {video && (
                  <CharchaVideo
                    video={video}
                    type="long"
                    sharetext={data[episodeId]}
                    handleShareData={handleShareData}
                  />
                )}
              </div>

              <div id="text">
                {text && (
                  <CharachaLekh text={text} handleShareData={handleShareData} sharetext={data[episodeId]} />
                )}
              </div>

              <div id="graphics">
                {graphics && (
                  <Graphics
                    graphics={graphics}
                    handleShareData={handleShareData}
                    sharetext={data[episodeId]}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default AllEpisodeTab;
